import { render, staticRenderFns } from "./LeaseScheduledPaymentsTabScreen.vue?vue&type=template&id=45a3c932&"
import script from "./LeaseScheduledPaymentsTabScreen.vue?vue&type=script&lang=js&"
export * from "./LeaseScheduledPaymentsTabScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports